/**
 * @desc 创建订舱需求
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(aono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/createCabinAdvance/${aono}`, {
      method: "GET",

      ...options,
    }),
  );
}
